import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "progress-line" }

import { useTaskStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressLine',
  setup(__props) {


// Store
const taskStore = useTaskStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(taskStore).countScreens, (cell) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["progress-line__cell", {'progress-line__cell_active': cell === _unref(taskStore).screen + 1}])
      }, null, 2))
    }), 256))
  ]))
}
}

})